export default __webpack_public_path__ + "static/images/invest-inset.2a56df68.png";